import { CallbackType } from '@forgerock/javascript-sdk';
import { updateOtpCountAction, updateOTPRequestedMultipleTimes, updateErrorCode } from 'components/Login/actions';
import { MESSAGE_OTP_EXPIRED, MESSAGE_MFA_CHANNEL, MESSAGE_OTP_RETRY_LIMIT } from 'components/Login/constants';
import removeSessionStorageAttributes from 'utils/removeSessionStorageAttributes';
import { updateErrorInState } from 'ciam-self-service-shared';
import { checkStep } from 'utils/authTree/helpers';
import { INVALID_OTP, RESEND_OTP, DIFFERENT_CHANNEL_SELECTION } from './constants';
import nextStep from './handleStep';
import makeChoiceResendOrRetry from './makeChoiceResendOrRetry';
import chooseResendOrRetryAfterOTPExpiry from './chooseResendOrRetryAfterOTPExpiry';
import sameChannelOrDifferent from './sameChannelOrDifferent';
import handleBackButtonClick from './handleBackButtonClick';
import { getCallbackOfTypeSafely, getCallbackWithMessageSafely, getCallbackWithPromptSafely } from '../authTreeUtils';

const executeFinalStepsForTryAnotherWay = async (dispatch, step, history, pathBuilder) => {
  let resultStage = null;
  const secondStep = await makeChoiceResendOrRetry(dispatch, step, RESEND_OTP);
  checkStep(secondStep, 'D_704');
  if (getCallbackWithMessageSafely(secondStep, MESSAGE_OTP_RETRY_LIMIT)) {
    await removeSessionStorageAttributes();
    updateErrorInState(dispatch, 'D_622', updateErrorCode);
    history.push(pathBuilder('/', true, { searchParams: { error_code: 'D_622' } }));
  } else {
    resultStage = await sameChannelOrDifferent(dispatch, secondStep, DIFFERENT_CHANNEL_SELECTION);
    checkStep(resultStage, 'D_704');
  }
  return resultStage;
};

const tryOTPAnotherWayAsyncAction = async (dispatch, payload) => {
  dispatch(updateErrorCode(null));
  let resultStage = null;
  const { history, realm, brand, pathBuilder, ciamHistory } = payload;
  let { stage } = payload;
  dispatch(updateOtpCountAction(0));
  dispatch(updateOTPRequestedMultipleTimes(true));
  sessionStorage.setItem('isOTPGeneratedMultipleTimes', true);

  // after clicking back button from email account
  stage = await handleBackButtonClick(stage, realm, brand, 'ciam.backButton-otp');
  checkStep(stage, 'D_704');

  if (getCallbackWithMessageSafely(stage, MESSAGE_OTP_RETRY_LIMIT)) {
    await removeSessionStorageAttributes();
    updateErrorInState(dispatch, 'D_622', updateErrorCode);
    history.push(pathBuilder('/', true, { searchParams: { error_code: 'D_622' } }));
  }

  const passwordCallback = getCallbackOfTypeSafely(stage, CallbackType.PasswordCallback);
  const textOutputCallback = getCallbackOfTypeSafely(stage, CallbackType.TextOutputCallback);
  const messageExpiredCallback = getCallbackWithMessageSafely(stage, MESSAGE_OTP_EXPIRED);
  if (passwordCallback) {
    passwordCallback.setPassword(INVALID_OTP);
    const step = await nextStep(dispatch, stage);
    checkStep(step, 'D_704');
    resultStage = await executeFinalStepsForTryAnotherWay(dispatch, step, history, pathBuilder);
  } else if (messageExpiredCallback) {
    const secondStep = await chooseResendOrRetryAfterOTPExpiry(dispatch, stage);
    checkStep(secondStep, 'D_704');
    resultStage = await executeFinalStepsForTryAnotherWay(dispatch, secondStep, history, pathBuilder);
  } else if (textOutputCallback || !messageExpiredCallback) {
    resultStage = await executeFinalStepsForTryAnotherWay(dispatch, stage, history, pathBuilder);
  } else {
    // nothing to do
  }

  if (resultStage && Object.keys(resultStage).length !== 0) {
    sessionStorage.setItem('ciam.backButton-otp', JSON.stringify(resultStage));
  }
  if (getCallbackWithPromptSafely(resultStage, MESSAGE_MFA_CHANNEL)) {
    ciamHistory.push('/mfa');
  }
};

export default tryOTPAnotherWayAsyncAction;
